import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect, Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import deepMerge from 'lodash/merge';
import * as _ from '../lodash';
import ClassPage from '../page/ClassPage';
import store from '../configureStore';
import { Product } from '../types';
import * as productActions from '../actions/products';
import * as frameActions from '../actions/frames';
import * as orderActions from '../actions/orders';
import * as settingActions from '../actions/settings';
import * as cartActions from '../actions/cart';
import { getTimeFrameFromDate } from '../utilities/timeUtility';
import { stringToBoolean } from '../utilities/conversionUtility';

const mapStateToProps = ({
  settings, product, order, frames: { frames, ...framesProps },
}) => ({
  frames,
  ...framesProps,
  ...settings,
  locale: window.bta.locale.substr(0, 2),
  isDemo: window.bta.isDemo,
  timeZone: window.bta.timeZone,
  capacityType: product.data.capacity ? product.data.capacity.type : 0,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  variants: product.data.variants,
  locations: product.data.locations,
  productOptions: product.data.options,
  maxAvailability: product.maxAvailability,
  totalPrice: order.totalPrice,
  totalQuantity: order.quantity,
  selectedDate: order.date,
  available: order.available,
  orderVariants: order.variants,
  selectedLocation: order.selectedLocation,
  selectedVariant: order.variantSelected,
  additionalDetails: order.additionalDetails,
  additionalDetailsValidationErrors: order.additionalDetailsValidationErrors,
  selectedTimeslot: order.selectedTimeslot,
});

const mapDispatchToProps = dispatch => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
  settingActions: bindActionCreators({ ...settingActions }, dispatch),
});

const ClassWidgetPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClassPage);

export default class ClassWidgetContainer extends Component {
  UNSAFE_componentWillMount() {
    let { settings, product, defaultTranslation, exceededTrialPlan } = this.props,
        newStyle = window.xprops.data && window.xprops.data.style;

    if (newStyle) settings = deepMerge(settings, { style: newStyle });
    if (window.xprops && window.xprops.onInit) window.xprops.onInit(settings.setting);

    store.dispatch(
      settingActions.setConfiguration({
        ...settings,
        defaultTranslation,
        exceededTrialPlan
      }),
    );

    if (!stringToBoolean(settings.setting.show_timezone_chooser)) {
      store.dispatch(
        settingActions.setLocalTimeZone(window.bta.timeZone)
      );
    }

    store.dispatch(productActions.fetchProduct(product)).then(() => {
      if (product.variants.length > 0) {
        store.dispatch(
          orderActions.setVariantsQuantity(`${product.variants[0].external_id}_quantity`, 1, { singleVariant: true }),
        );
      }
    });
  }

  componentDidMount() {
    const { settings: { setting }, product, exceededTrialPlan } = this.props,
          timeZone = stringToBoolean(setting.show_timezone_chooser) ? moment.tz.guess() : window.bta.timeZone,
          today = new Date(),
          { start, finish } = getTimeFrameFromDate(today, timeZone);

    if (!exceededTrialPlan) {
      store
        .dispatch(
          frameActions.fetchFrames({
            start: start.format(),
            finish: finish.format(),
          }),
        )
        .then(
          framesData => new Promise((resolve) => {
            if (framesData.frames.length === 0) {
              const { nextOccurrence } = framesData;
              if (nextOccurrence) {
                const params = getTimeFrameFromDate(nextOccurrence, timeZone);
                store.dispatch(frameActions.fetchFrames(params)).then((framesData2) => {
                  if (framesData2.frames.length > 0) {
                    resolve(framesData2);
                  } else {
                    resolve(framesData2);
                  }
                });
              } else {
                resolve(framesData);
              }
            } else {
              resolve(framesData);
            }
          }),
        );
    }

    if (window.xprops && window.xprops.onInit) window.xprops.onInit(setting);
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <ClassWidgetPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = value => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation(key, value));
};
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting(key, value));

ClassWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
